import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'arrows-exchange-2',
  'IconArrowsExchange2',
  [
    ['path', { d: 'M17 10h-14l4 -4', key: 'svg-0' }],
    ['path', { d: 'M7 14h14l-4 4', key: 'svg-1' }],
  ],
);
